import React, { useMemo } from 'react';
import { IconPlaceholder } from './IconPlaceholder';
import { PlaceholderElement } from './Placeholder.style';
export var Placeholder = _ref => {
  var {
    variant,
    size,
    name
  } = _ref;
  var firstLetter = useMemo(() => name === null || name === void 0 ? void 0 : name.charAt(0).toUpperCase(), [name]);
  return /*#__PURE__*/React.createElement(PlaceholderElement, {
    variant: variant,
    size: size
  }, !!name && firstLetter, !name && !firstLetter && /*#__PURE__*/React.createElement(IconPlaceholder, {
    variant: variant
  }));
};
//# sourceMappingURL=Placeholder.js.map